import * as React from "react"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"
import env from "../../../../env"
import { IBreadcrumb } from "../../index"

interface Props {
    currentList: IBreadcrumb
}

export const CurrentList = ({
    currentList: { isListHidden, listName, listUrl },
}: Props): JSX.Element =>
    isListHidden ? (
        <span className="label" data-ft-list-hidden data-ft-list-of-item>
            {listName}
        </span>
    ) : (
        <ActionAnchor
            href={env.applicationPath + listUrl}
            isLabel={true}
            data-ft-list-hidden={false}
            data-ft-list-of-item
        >
            {listName}
        </ActionAnchor>
    )

export default CurrentList
